import React, { useState } from 'react';

function Login({ onLogin }) {
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const res = await fetch('/api/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ login, password })
      });

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.error || 'Ошибка входа');
      }

      localStorage.setItem('token', data.token);
      localStorage.setItem('user', JSON.stringify(data.user));

      onLogin(data.user);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-box">
        <div className="login-header">
          <h1>🏭 Расстановка персонала</h1>
          <p>Войдите в систему</p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Логин</label>
            <input
              type="text"
              value={login}
              onChange={(e) => setLogin(e.target.value)}
              placeholder="Ваш логин"
              autoFocus
              required
            />
          </div>

          <div className="form-group">
            <label>Пароль</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Ваш пароль"
              required
            />
          </div>

          {error && <div className="login-error">❌ {error}</div>}

          <button type="submit" className="login-btn" disabled={loading}>
            {loading ? '⏳ Вход...' : 'Войти'}
          </button>
        </form>

        <div className="login-hint">
          <p><b>Тестовые аккаунты:</b></p>
          <p>director / admin123</p>
          <p>hr / hr123</p>
          <p>fасовка_шеф / fasovka123</p>
        </div>
      </div>
    </div>
  );
}

export default Login;